/** @module csi/skintheme/Indigo */
define([], function() {
	return {
		Blue1: "Blue30",
		Blue2: "Blue50",
		Blue3: "Blue500",

		PrimaryBlue: "Blue800",
		PrimaryDisabledColor: "Blue200",
		PrimaryColor2: "Blue700",
		PrimaryColor3: "Black200",

		SiteHeaderBackground: "Blue800",

		CompanyHeaderBlue1: "Blue800",
		CompanyHeaderBlue2: "Blue700",

		/* LINK */
		LinkNormal: "Blue600",
		LinkHover: "Blue800",
		LinkActive: "Blue600",

		/* Comment */
		CommentActiveColor: "Blue600",

		/** custom view */
		CustomViewOptionActiveColor: "Blue500",

		/* FULL SCREEN HEADER */
		FullScreenHeaderBackgroundColor: "Blue800",
		FullScreenLogoBackgroundColor: "Blue800",

		/* TEXT */
		TabsTextActive: "PrimaryBlue",

		/* Button */
		BtnPrimaryFocusedBorderColor: "Black200",
		ButtonSwitchNormalIconStateOnBackgroundColor: "Blue800",

		/* BreadCrumb */
		BreadcrumbNormalLinkColor: "Blue600",

		/* CheckBox */
		CheckBoxFocusColor: "Blue300",

		/* Text Border */
		TextfieldActiveBorderColor: "PrimaryColor",
		BtnToolbarFocusedBorderColor: "PrimaryColor",

		/* DropDown */
		DropdownSelectActiveBorderColor: "PrimaryColor",

		/* Header */
		LastVisitedBackgroundColor: "PrimaryWhite",
		LastVisitedIconColor: "SiteHeaderBackground",
		PageHeaderButtonTextColor: "PrimaryWhite",
		PageHeaderToolbarIconColor: "PrimaryWhite",
		PageHeaderToolbarHoverColor: "PrimaryWhite",
		PageHeaderSearchInButtonHoverColor: "BtnSecondaryHoverBackgroundColor",
		PageHeaderToolbarSeparatorColor: "WhiteOpacity20",
		PageHeaderSearchScopeBackgroundColor: "BtnSecondaryNormalBackgroundColor",
		PageHeaderSearchBlockBackgroundColor: "TextfieldNormalBackgroundColor",
		CompanyLogoTextColor: "WhiteTextColor",
		CompanyLogoImageURL: "DarkCompanyLogoIconURL",
		ExitFullScreenIconURL: "DarkExitFullScreenIconURL",

		/* Table */
		TableCopyBorderColor: "Blue600",
		TablePasteBorderColor: "Blue600",
		TableNewRowBackgroundColor: "Blue100",

		/* Slicer */
		SlicerMetricsBackgroundColor: "Blue100",

		/* Chart */
		ChartAreaURL: "ChartAreaBlueURL",
		ChartBarURL: "ChartBarBlueURL",
		ChartColumnURL: "ChartColumnBlueURL",
		ChartDoughnutURL: "ChartDoughnutBlueURL",
		ChartLineURL: "ChartLineBlueURL",
		ChartMsAreaURL: "ChartMsAreaBlueURL",
		ChartMsBarURL: "ChartMsBarBlueURL",
		ChartMsColumnURL: "ChartMsColumnBlueURL",
		ChartMsLineURL: "ChartMsLineBlueURL",
		ChartParetoURL: "ChartParetoBlueURL",
		ChartPieURL: "ChartPieBlueURL",
		ChartStackedAreaURL: "ChartStackedAreaBlueURL",
		ChartStackedBarURL: "ChartStackedBarBlueURL",
		ChartStackedColumnURL: "ChartStackedColumnBlueURL",

		/* Progress bar */
		ProgressBarDeterminateProgressColor: "Blue600",

		HighlightSelected: "Grey200"
	};
});